import { b as p } from "../../index-34b1f277.js";
const e = p("elevation-color-one"), x = p("elevation-color-two"), o = {
  50: `0px 1px 4px 0px ${e.reference}`,
  100: `0px 2px 8px 0px ${e.reference}`,
  200: `0px 4px 16px 0px ${e.reference}`,
  300: `0px 8px 24px 0px ${e.reference}`,
  400: `0px 32px 64px 0px ${e.reference}, 0px 2px 16px 0px ${x.reference}`
};
export {
  e as $elevation1,
  x as $elevation2,
  o as shadows
};
//# sourceMappingURL=shadows.es.js.map
